import { render, staticRenderFns } from "./ImportIndex.vue?vue&type=template&id=3cdf59f4&scoped=true"
import script from "./ImportIndex.vue?vue&type=script&lang=js"
export * from "./ImportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdf59f4",
  null
  
)

export default component.exports